// Basic
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';

// Modules
import { MaterialModule } from '@app/material.module';

// Components
import { AuxiliarSearchOptionsShellComponent } from './auxiliar-search-options-shell.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule
  ],
  declarations: [AuxiliarSearchOptionsShellComponent],
  exports: [AuxiliarSearchOptionsShellComponent],
  entryComponents: [AuxiliarSearchOptionsShellComponent]
})
export class AuxiliarSearchOptionsShellModule { }
